import React from 'react';
import { Drawer, Box } from "@mui/material";
import SidebarItems from './SidebarItems';
//import { makeStyles } from "@mui/styles";
//import SidebarStyles from '../../../styles/jss/components/SidebarStyles';
import { useSelector } from "react-redux";
import theme from '../../../theme';
import {ToggleSidebar} from "../../../redux/actions";
import {useDispatch} from "react-redux";
import { drawerWidth } from '../../../styles/aero';
import { grey } from '@mui/material/colors';

//const useStyles = makeStyles(SidebarStyles);

const MainSidebar = (props) => {
    //const classes = {};//useStyles();
    const sidebar = useSelector(state => state.sidebar);
    const { window } = props;
    const container = window !== undefined ? () => window().document.body : undefined;
    const dispatch = useDispatch();

    return (
        <nav aria-label="mailbox folders" sx={{flexShrink: { sm: 0 }, width: { sm: drawerWidth }}}>
            {/* The implementation can be swapped with js to avoid SEO duplication of links. */}
            <Box sx={{ display: { xs: "block", sm: "none" } }} implementation="css">
                <Drawer
                    container={container}
                    variant="temporary"
                    anchor={'left'}
                    open={sidebar.open && sidebar.screenWidth < theme.breakpoints.values.sm}
                    onClose={() => dispatch(ToggleSidebar())}
                    slotProps={{
                      paper: {sx: { backgroundColor: grey[900], width: drawerWidth }}
                    }}
                    ModalProps={{
                        keepMounted: true, // Better open performance on mobile.
                    }}
                >
                    <SidebarItems />
                </Drawer>
            </Box>
            <Box sx={{ display: { xs: "none", sm: "block" } }} implementation="css">
                <Drawer
                    slotProps={{
                      paper: {sx: { backgroundColor: grey[900], width: drawerWidth }}
                    }}
                    variant="persistent"
                    sx={{flexShrink: { sm: 0 }, width: { sm: drawerWidth }}}
                    anchor="left"
                    open={sidebar.open}
                >
                    <SidebarItems/>
                </Drawer>
            </Box>
        </nav>
    );
};

export default MainSidebar;